/**
 * Métadonnées des familles de filières — alignées sur ficheTechnique.md § « FILIÈRES DE FORMATION ».
 * Les formations listées viennent de l’API `/filieres` (base admin), pas de listes statiques ici.
 */

export type DomaineVitrineMeta = {
  domaineKey: string;
  slug: string;
  title: string;
  intro: string;
  urlImage?: string | null;
  icon: string;
};

/** Ordre d’affichage vitrine (fiche technique). */
export const DOMAINE_ORDER = [
  'NUMERIQUE',
  'ADMIN',
  'COMMUNICATION',
  'TECHNIQUE',
  'ENTREPRENEURIAT',
] as const;

export const DOMAINE_VITRINE: Record<string, DomaineVitrineMeta> = {
  NUMERIQUE: {
    domaineKey: 'NUMERIQUE',
    slug: 'numeriques-technologiques',
    title: 'Filières numériques et technologiques',
    intro:
      'Développement d\'application web et mobile, cybersécurité et technologies numériques.',
    icon: 'monitoring',
  },
  ADMIN: {
    domaineKey: 'ADMIN',
    slug: 'administratives-gestion',
    title: 'Filières administratives et de gestion',
    intro: 'Droit professionnel, comptabilité, secrétariat de direction et gestion.',
    icon: 'account_balance',
  },
  COMMUNICATION: {
    domaineKey: 'COMMUNICATION',
    slug: 'communication-marketing',
    title: 'Filières communication et marketing',
    intro: 'Anglais professionnel, marketing digital, communication et design visuel.',
    icon: 'campaign',
  },
  TECHNIQUE: {
    domaineKey: 'TECHNIQUE',
    slug: 'techniques-professionnelles',
    title: 'Filières techniques et professionnelles',
    intro: 'Génie, architecture, accueil, protocole, relations publiques et événementiel.',
    icon: 'inventory_2',
  },
  ENTREPRENEURIAT: {
    domaineKey: 'ENTREPRENEURIAT',
    slug: 'entrepreneuriales-strategiques',
    title: 'Filières entrepreneuriales et stratégiques',
    intro:
      'Entrepreneuriat, leadership et compétences stratégiques pour l\'emploi et l\'innovation.',
    icon: 'rocket_launch',
  },
};

/** Organisation générale des formations — ficheTechnique.md */
export const FORMATION_ORGANISATION = {
  durationLabel: 'Organisation (fiche officielle)',
  /** Fallback si le planning filière n’est pas encore chargé (modales, etc.). */
  duration: 'Cohortes de 2 mois · 3 séances par semaine.',
  cadreItems: [
    'Fonctionnement du lundi au samedi',
    'Six vacations par jour · horaire 08h00 – 20h00',
    'Trois séances par semaine pour chaque filière',
    'Durée d’une cohorte : deux mois',
    'Capacité : 80 apprenants par vacation (centre)',
  ],
} as const;

export function getDomaineMetaBySlug(
  slug: string | undefined,
  domaines?: Array<{
    code: string;
    libelle: string;
    slug: string;
    intro?: string | null;
    urlImage?: string | null;
    icon?: string;
  }>,
): DomaineVitrineMeta | undefined {
  if (!slug) return undefined;
  const fromApi = domaines?.find((d) => d.slug === slug);
  if (fromApi) {
    return {
      domaineKey: fromApi.code.toUpperCase(),
      slug: fromApi.slug,
      title: fromApi.libelle,
      intro: fromApi.intro?.trim() ?? '',
      urlImage: fromApi.urlImage ?? null,
      icon: fromApi.icon ?? 'school',
    };
  }
  return Object.values(DOMAINE_VITRINE).find((d) => d.slug === slug);
}

export function getDomaineMetaByKey(domaineKey: string | undefined): DomaineVitrineMeta | undefined {
  if (!domaineKey) return undefined;
  return DOMAINE_VITRINE[domaineKey.toUpperCase()];
}
